// src/pages/About.js
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookOpen,
  faBrush,
  faComments,
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
  faShieldAlt,
  faHeart,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

export default function About() {
  return (
    <div className="about-container full-width">

      {/* Hero Intro */}
      <section className="about-intro">
        <h1>About WePrint PhotoBooks</h1>
        <p>
          At WePrint PhotoBooks, we don’t just print — we preserve memories. Born from a love of photography and storytelling, we create premium photobooks that bring your moments to life.
        </p>
        <p>
          From birthdays to weddings, travels to baby’s first steps — we help turn your pictures into timeless, tactile treasures.
        </p>
      </section>

      {/* Company Story */}
      <section className="story-section">
        <h2>Our Journey</h2>
        <p>
          Founded in Bengaluru, our small team of designers, editors, and print experts had one goal: to provide a custom photobook experience with a personal touch. Over the years, we’ve grown with our customers — constantly evolving, but always putting memories first.
        </p>
        <p>
          We understand how precious your photos are, and we treat every order like it’s our own family album.
        </p>
      </section>

      {/* CEO & Team */}
      <section className="team-section">
        <h2>Meet the Founder</h2>
        <div className="ceo">
          <img src="https://source.unsplash.com/200x200/?woman,business" alt="CEO" />
          <div>
            <h3>Aishwarya Kengal</h3>
            <p>
              With an eye for design and a passion for storytelling, Aishwarya leads a team focused on quality, creativity, and customer connection.
            </p>
          </div>
        </div>

        <h2>Our Team</h2>
        <div className="team-grid">
          {['Creative Director', 'Lead Editor', 'Customer Relations', 'Print Master', 'Digital Artist', 'Quality Specialist'].map((role, i) => (
            <div className="member" key={i}>
              <img src={`https://source.unsplash.com/150x150/?portrait,team,${i}`} alt={role} />
              <h4>{role}</h4>
              <p>Passionate professionals who bring your memories to life, beautifully.</p>
            </div>
          ))}
        </div>
      </section>

      {/* Services */}
      <section className="services-section">
        <h2>What We Do</h2>
        <div className="services-grid">
          <div className="service">
            <FontAwesomeIcon icon={faBookOpen} className="icon" />
            <h4>Custom PhotoBooks</h4>
            <p>Personalized books with elegant layouts and premium prints.</p>
          </div>
          <div className="service">
            <FontAwesomeIcon icon={faBrush} className="icon" />
            <h4>Photoshop Services</h4>
            <p>Remove blemishes, fix colors, retouch photos — professionally.</p>
          </div>
          <div className="service">
            <FontAwesomeIcon icon={faComments} className="icon" />
            <h4>Creative Consulting</h4>
            <p>Our team helps you select designs, messages, and perfect finishes.</p>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <ol>
          <li><FontAwesomeIcon icon={faCheckCircle} /> Upload Your Photos or Visit Us</li>
          <li><FontAwesomeIcon icon={faCheckCircle} /> Pick a Style, Theme, and Layout</li>
          <li><FontAwesomeIcon icon={faCheckCircle} /> Preview and Approve</li>
          <li><FontAwesomeIcon icon={faCheckCircle} /> Get Your Book Delivered or Picked Up</li>
        </ol>
      </section>

      {/* Client Highlights */}
      <section className="clients-section">
        <h2>Trusted by Thousands</h2>
        <p>We've printed over <strong>10,000 photobooks</strong> for families, artists, travelers, and professionals across India.</p>
        <p>Our happy customers become lifelong storytellers.</p>
      </section>

      {/* Testimonials Teaser */}
      <section className="testimonials-preview">
        <h2>Words from Our Clients</h2>
        <blockquote>“Absolutely loved my wedding book. Beautiful quality and superb service. Thank you!”</blockquote>
        <cite>— Priya Sharma, Bangalore</cite>
      </section>

      {/* Trust & Security */}
      <section className="trust-section">
        <h2>Secure. Reliable. Personal.</h2>
        <p><FontAwesomeIcon icon={faShieldAlt} /> Your photos are encrypted and handled with strict privacy and care.</p>
        <p><FontAwesomeIcon icon={faHeart} /> Every order is handmade, reviewed, and approved by our quality team.</p>
      </section>

      {/* Location */}
      <section className="location-section">
        <h2>Visit Our Studio</h2>
        <p><FontAwesomeIcon icon={faMapMarkerAlt} /> #37, Sannidhi Rd, NR Colony, Basavanagudi, Bengaluru, Karnataka 560004</p>
        <p><FontAwesomeIcon icon={faPhoneAlt} /> <a href="tel:+918861494444">+91 88614 94444</a></p>
        <p><FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a></p>

        <iframe
          title="WePrint PhotoBooks Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8322805674166!2d77.56774347564448!3d12.92838568738784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15c726e3a3a9%3A0x44d116c60dcf6a1e!2sWePrint%20PhotoBooks!5e0!3m2!1sen!2sin!4v1692528394375!5m2!1sen!2sin"
          width="100%"
          height="300"
          style={{ border: 0, marginTop: '20px', borderRadius: '10px' }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </section>

      {/* Final CTA */}
      <section className="about-cta">
        <h2>Let’s Bring Your Photos to Life</h2>
        <p>Contact us today to begin your photobook journey — with love, design, and care.</p>
        <a href="/contact" className="primary-btn">Get Started</a>
      </section>
    </div>
  );
}
